import { DonationFundPlatformTypeEnum } from '@graphql/generated';

export const getPaymentLink = (paymentMethod?: Maybe<DonationFundPlatformTypeEnum>, username?: Maybe<string>, amount?: string, note?: string) => {
  switch (paymentMethod) {
    case DonationFundPlatformTypeEnum.cashapp:
      return `https://cash.app/$${username}`;
    case DonationFundPlatformTypeEnum.paypal:
      return `https://paypal.me/${username}`;
    case DonationFundPlatformTypeEnum.venmo:
      return `https://venmo.com/u/${username}`;
    default:
      return '';
  }
};
